module.exports = __webpack_public_path__ + "img/icon-subtitle.8b836266.svg";